<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-card>
      <el-form :inline="true">
        <el-form-item label="采购单号">
          <el-input v-model.trim="formInline.purchaseOrderNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="Shipment No.">
          <el-input v-model.trim="formInline.shipmentNo" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportInvoice">生成发票</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 60px">
      <div style="font-size: 50px;font-weight: bold;padding: 20px 0">大中华商家发票</div>
      <el-form :inline="true">
        <el-form-item label="采购订单">
          <el-input v-model="formInline2.purchaseOrderNo" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportInvoice2">生成发票</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { downloadUrlFile } from '@/utils/functions';
import { exportInvoice } from './rate/api';

export default {
  data() {
    return {
      fullscreenLoading: false,
      formInline: {
        purchaseOrderNo: null,
        shipmentNo: null,
      },
      formInline2: {
        purchaseOrderNo: null,
      },
    };
  },
  methods: {
    exportInvoice() {
      if (!this.formInline.purchaseOrderNo && !this.formInline.shipmentNo) {
        this.$message('请输入采购单号或Shipment No.');
        return;
      }
      if (this.formInline.purchaseOrderNo && this.formInline.shipmentNo) {
        this.$message('采购单号和Shipment No.只能填一个');
        return;
      }
      exportInvoice(this.formInline).then(res => {
        if (res.data && res.data.success) {
          downloadUrlFile(res.data.data);
        } else {
          this.$message.error(res.data.message || '系统错误，请稍后再试');
        }
      });
    },
    exportInvoice2() {
      if (!this.formInline2.purchaseOrderNo) {
        this.$message('请输入采购单号.');
        return;
      }
      exportInvoice({
        shipmentNo: null,
        purchaseOrderNos: this.formInline2.purchaseOrderNo.replace(/\s+/g, ',').split(",")
      }).then(res => {
        if (res.data && res.data.success) {
          downloadUrlFile(res.data.data);
        } else {
          this.$message.error(res.data.message || '系统错误，请稍后再试');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 20px;
}
.shoppe {
  padding: 20px;
}
</style>
